import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch SubCategory List Data
export const fetchSubCategoryList = createAsyncThunk(
  "subCategory/fetchSubCategoryList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/subCategory");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add SubCategory to the List
export const addSubCategoryList = createAsyncThunk(
  "subCategory/addSubCategoryList",
  async (newSubCategoryData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/subCategory", newSubCategoryData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update SubCategory List Data
export const updateSubCategoryList = createAsyncThunk(
  "subCategory/updateSubCategoryList",
  async (subCategoryData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/subCategory", subCategoryData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// SubCategory List Slice
const subCategorySlice = createSlice({
  name: "subCategory",
  initialState: {
    subCategoryList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch SubCategory List
      .addCase(fetchSubCategoryList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSubCategoryList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subCategoryList = action.payload;
      })
      .addCase(fetchSubCategoryList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add SubCategory
      .addCase(addSubCategoryList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addSubCategoryList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addSubCategoryList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update SubCategory List
      .addCase(updateSubCategoryList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateSubCategoryList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateSubCategoryList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = subCategorySlice.actions;

export default subCategorySlice.reducer;